import Component from './components/CFDIS';
import { PATH } from './constants';

export { PATH };
export default Component;
